import { createContext, useContext, useState } from 'react';

interface NavDrawerContextValue {
  open: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const NavDrawerContext = createContext<NavDrawerContextValue>({
  open: false,
  openDrawer: () => {},
  closeDrawer: () => {},
});

export const NavDrawerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <NavDrawerContext.Provider value={{ open, openDrawer: () => setOpen(true), closeDrawer: () => setOpen(false) }}>
      {children}
    </NavDrawerContext.Provider>
  );
};

export const useNavDrawer = () => useContext(NavDrawerContext);
